import React from 'react';
export function Header() {
  return <header className="border-b border-gray-200 px-4 py-3" data-id="element-239">
      <div className="flex justify-between items-center" data-id="element-240">
        <div className="text-sm text-gray-500" data-id="element-241">Advertorial</div>
        <div className="text-sm text-gray-500" data-id="element-242">3. September 2025</div>
      </div>
    
    </header>;
}